<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸检测与跟踪</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的YUV数据进行人脸检测、跟踪，调用该接口前必须成功调用SKFaceVideoTrackInit接口，该接口与Image人脸检测接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceVideoTrackYUV(byte[] YUVData, 
final FaceDetectCallbackInterface FaceDetectCallback)
// 人脸检测结果回调接口
public interface FaceDetectCallbackInterface {
 void FaceDetectCallback (FaceStruct[] FaceStructs);
}
public FaceStruct[] SKFaceVideoTrackYUV(byte[] YUVData)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）YUVData：视频帧的YUV数据</p>
             <p class="doc_main_p">（2）FaceDetectCallback(FaceStruct[] FaceStructs): 人脸检测结果回调FaceStructs检测结果结构体数组</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">数据结构（数组）</p>
		<test-result-rtructure></test-result-rtructure>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceVideoTrackYUV(data, 
new FaceDetectCallbackInterface() {
@Override
public void FaceDetectCallback(FaceStruct[] FaceStructs) {
// TODO:此处FaceStructs即是识别结果的返回值，请勿在方法内做任何耗时操作}
 });
FaceStruct[] FaceStructs = skFace.SKFaceVideoTrackYUV(data);</code></pre>
</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import TestResultStructure from '../../../../components/testResultStructure.vue';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'test-result-rtructure':TestResultStructure
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','视频接口','Video人脸检测与跟踪'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/voideinitiali/voidedetection.vue